/**
 * PoseSelector Component
 * Wybór predefiniowanych póz dla generacji video
 */

import React from 'react';
import { VideoPose } from '../../api/video';
import './PoseSelector.css';

interface PoseSelectorProps {
  poses: VideoPose[];
  selectedPoseId?: string;
  onSelectPose: (poseId: string) => void;
  isAdmin: boolean;
}

export const PoseSelector: React.FC<PoseSelectorProps> = ({
  poses,
  selectedPoseId,
  onSelectPose,
  isAdmin,
}) => {
  return (
    <div className="pose-selector">
      <h3>Wybierz pozę</h3>

      <div className="pose-grid">
        {poses.map((pose) => (
          <div
            key={pose.id}
            className={`pose-card ${selectedPoseId === pose.id ? 'selected' : ''}`}
            onClick={() => onSelectPose(pose.id)}
          >
            {/* Preview Image */}
            {pose.preview_image && (
              <div className="pose-preview">
                <img
                  src={pose.preview_image}
                  alt={pose.name}
                  loading="lazy"
                />
              </div>
            )}

            {/* Pose Name */}
            <div className="pose-name">{pose.name}</div>

            {/* Admin-only: Show prompt */}
            {isAdmin && pose.prompt && (
              <div className="pose-prompt-preview">
                <small>{pose.prompt.substring(0, 60)}...</small>
              </div>
            )}
          </div>
        ))}
      </div>

      {!isAdmin && (
        <p className="pose-info-text">
          💡 Wybrany prompt pozy zostanie automatycznie dodany do Twojego opisu
        </p>
      )}
    </div>
  );
};
